export const bookingsStatusColorCode = [
    {
        label: "open",
        colorBg: "bg-[#F9E5D4]",
        colorText: "text-[#DE6F0D]"
    },
    {
        label: "rental",
        colorBg: "bg-[#E8F5E9]",
        colorText: "text-[#22C55E]"
    },
    {
        label: "completed",
        colorBg: "bg-[#E8EEF9]",
        colorText: "text-[#1D4ED8]"
    },
    {
        label: "cancelled",
        colorBg: "bg-[#FEE2E2]",
        colorText: "text-[#DC2626]"
    },
    {
        label: "cancelled paid",
        colorBg: "bg-[#FCE7F3]",
        colorText: "text-[#BE185D]"
    },
    {
        label: "quotes",
        colorBg: "bg-[#CCFBF1]",
        colorText: "text-[#0F766E]"
    },
    {
        label: "pending",
        colorBg: "bg-[#F3F4F6]",
        colorText: "text-[#6B7280]"
    },
    {
        label: "no show",
        colorBg: "bg-[#FCE7F3]",
        colorText: "text-[#7D1C4A]"
    },
    {
        label: "reopen",
        colorBg: "bg-[#FEF9C3]",
        colorText: "text-[#CA8A04]"
    },
    {
        label: "overdue",
        colorBg: "bg-[#EDE9FE]",
        colorText: "text-[#7C3AED]"
    },
    {
        label: "repair",
        colorBg: "bg-[#E0F2FE]",
        colorText: "text-[#0284C7]"
    },
    {
        label: "blocked",
        colorBg: "bg-[#E5E7EB]",
        colorText: "text-[#374151]"
    }
];

export const supportTicketStatusColorCode = [
    {
        label: "new",
        colorBg: "bg-[#F3CBA9]",
        colorText: "text-[#DE6F0D]"
    },
    {
        label: "resolved",
        colorBg: "bg-[#D9F4D4]",
        colorText: "text-[#039855]"
    },
    {
        label: "assigned",
        colorBg: "bg-[#CCE4F7]",
        colorText: "text-[#1B2AFE]"
    },
    {
        label: "pending assignment",
        colorBg: "bg-[#FEDFDD]",
        colorText: "text-[#D92D20]"
    },
    {
        label: "closed",
        colorBg: "bg-[#9ACBD0]",
        colorText: "text-[#006A71]"
    },
    {
        label: "awaiting input",
        colorBg: "bg-[#E27861]",
        colorText: "text-[#673128]"
    },
    {
        label: "on hold",
        colorBg: "bg-[#D256B0]",
        colorText: "text-[#7D1C4A]"
    },
]


export const paymentRequestStatusColorCode = [
    {
        label: "sent",
        colorBg: "bg-[#9ACBD0]",
        colorText: "text-[#006A71]"
    },
    {
        label: "opened",
        colorBg: "bg-[#F3CBA9]",
        colorText: "text-[#DE6F0D]"
    },
    {
        label: "paid",
        colorBg: "bg-[#CCE4F7]",
        colorText: "text-[#1B2AFE]"
    },
    {
        label: "expired",
        colorBg: "bg-[#FEDFDD]",
        colorText: "text-[#D92D20]"
    }
]

export const disableVehicleLocationStatusColorCode = [
    {
        label: "sent",
        colorBg: "bg-[#9ACBD0]",
        colorText: "text-[#006A71]"
    },
    {
        label: "opened",
        colorBg: "bg-[#F3CBA9]",
        colorText: "text-[#DE6F0D]"
    },
    {
        label: "responded",
        colorBg: "bg-[#FEDFDD]",
        colorText: "text-[#D92D20]"
    }
]

export const relocationStatusColorCode = [
    {
        value: "1",
        label: "Not Started",
        colorBg: "bg-[#F3CBA9]",
        colorText: "text-[#DE6F0D]"
    },
    {
        value: "2",
        label: "In Transit",
        colorBg: "bg-[#D9F4D4]",
        colorText: "text-[#039855]"
    },
    {
        value: "3",
        label: "Completed",
        colorBg: "bg-[#CCE4F7]",
        colorText: "text-[#1B2AFE]"
    }
]

export const vendorStatusCode = [
    {
        label: "good",
        colorBg: "bg-[#DCFCE7]",
        colorText: "text-[#166534]"
    },
    {
        label: "ban",
        colorBg: "bg-[#FEE2E2]",
        colorText: "text-[#991B1B]"
    },
    {
        label: "not credit",
        colorBg: "bg-[#DBEAFE]",
        colorText: "text-[#1D4ED8]"
    }
];


export const repairOrderStatusColorCode = [
    {
        label: "pending",
        colorBg: "bg-[#F3F4F6]",
        colorText: "text-[#6B7280]"
    },
    {
        label: "skipped",
        colorBg: "bg-[#F9E5D4]",
        colorText: "text-[#DE6F0D]"
    },
    {
        label: "inprogress",
        colorBg: "bg-[#E8F5E9]",
        colorText: "text-[#22C55E]"
    },
    {
        label: "done",
        colorBg: "bg-[#E8EEF9]",
        colorText: "text-[#1D4ED8]"
    }  
]